// extracted by mini-css-extract-plugin
export default {"chip":"chip__fia72","disabled":"disabled__zw5mb"};